export function setItem(key, object) {
  var app = (localStorage.getItem('app') &&  JSON.parse(localStorage.getItem('app') || '{}')) || (router.push('/login'));
  localStorage.setItem(`${key}.app.${app.code}`, object);
}

export  function getItem(key) {
  var app = (localStorage.getItem('app') &&  JSON.parse(localStorage.getItem('app') || '{}')) || (router.push('/login'));
  return localStorage.getItem(`${key}.app.${app.code}`);
}
